import { AggregateForItems, GetActiveAggregates } from '~types/search'

const getActiveAggregates = (
  props: GetActiveAggregates
): AggregateForItems[] => {
  return props.aggregates.map((aggregate) => ({
    key: aggregate.name,
    label: aggregate.name,
    contentProps: {
      aggregate,
      value: aggregate.value,
      valueListener: props.valueListener,
      currencyLocale: props.currencyLocale,
      currencyFormat: props.currencyFormat,
    },
  }))
}

export default getActiveAggregates
